module.exports = __webpack_public_path__ + "static/media/duck.d3d9013d.svg";